import React from 'react';
import slColors from 'sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
  numberOfBars: number;
}

export default function EvidenceSignalBars({
  numberOfBars,
  color = slColors.gray.DEFAULT,
  ...props
}: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="8" width="4" height="8" rx="2" fill={`${numberOfBars > 0 ? color : '#EDEDFB'}`} />
      <rect
        x="6"
        y="4"
        width="4"
        height="12"
        rx="2"
        fill={`${numberOfBars > 1 ? color : '#EDEDFB'}`}
      />
      <rect x="12" width="4" height="16" rx="2" fill={`${numberOfBars > 2 ? color : '#EDEDFB'}`} />
    </svg>
  );
}
